import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
export var CodeInline = styled.code(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: monospace;\n\n  background: #f8f8f8;\n  border: 1px solid #eeeeee;\n  padding: 2px 5px;\n"], ["\n  font-family: monospace;\n\n  background: #f8f8f8;\n  border: 1px solid #eeeeee;\n  padding: 2px 5px;\n"])));
var templateObject_1;
//# sourceMappingURL=CodeInline.js.map